<template>
  <el-form
    :value="value"
  >
    <div class="row">
      <div class="col-6">
        <el-form-item
          :label="L10n('employee')"
          prop="employeeID"
          class="material-style">
          <select-response
            :model.sync="value.employeeID"
            @update:model="handlerFilter('employeeID', $event)"
            :data="dataSourceEmployee.records"
            :isLoading="dataSourceEmployee.isLoading"
          />
        </el-form-item>
      </div>
      <div class="col-3">
        <el-form-item
          prop="year"
          :label="L10n('year')"
          class="material-style"
        >
          <select-response
            :model.sync="value.year"
            @update:model="handlerFilter('year', $event)"
            :data="sourceYear"
            :clearable="false"
          />
        </el-form-item>
      </div>
      <div class="col-3">
        <el-form-item
          prop="month"
          :label="L10n('month')"
          class="material-style"
        >
          <select-response
            :model.sync="value.month"
            @update:model="handlerFilter('month', $event)"
            :data="sourceMonth"
            :clearable="false"
          />
        </el-form-item>
      </div>
    </div>
  </el-form>
</template>

<script>
import { months } from '@/utils/months'
export default {
  name: 'LayoutFilters',
  props: {
    value: { type: Object, required: true }
  },
  computed: {
    dataSourceCondition () {
      return this.API('Conditions/GetAllDynamic?select=id,title&orderBy=title asc')
    },
    dataSourceEmployee () {
      return this.API('Employees/GetAllDynamic?select=id,name as title&filter=isActive==true&orderBy=name')
    },
    sourceYear () {
      let currentYear = new Date().getFullYear()
      let lastYear = 2019
      let result = []
      while (currentYear >= lastYear) {
        result.push({ id: currentYear, title: currentYear })
        currentYear--
      }
      return result
    },
    sourceMonth () {
      return months.map(({ id, labelKey }) => ({
        id: id,
        title: this.L10n(labelKey)
      }))
    }
  },
  methods: {
    handlerFilter (fieldName, value) {
      this.$emit('input', Object.assign({}, this.value, { [fieldName]: value }))
      this.$emit('on-filter')
    }
  }
}
</script>
